import React, { useState, useContext, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useForm, Controller } from "react-hook-form";
import { UserInputData } from '../WarrantyFrame';
import Checkbox from '@mui/material/Checkbox';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
//import Toggle, { TOGGLE_STATES } from '../../../Toggle'

export default function InsForm3MT(props) {
    const { currentState, setCurrentState } = useContext(UserInputData);
    const { control, getValues, setValue, watch } = useForm({
        defaultValues: { ...currentState, ...currentState },
        mode: 'onChange'
    });
    const [valueOnChange, setValueOnChange] = useState(false)
    const [isComplete, setIsComplete] = useState(0)
    const [resetValues, setResetValues] = useState(false)

    const [checkList, setCheckList] = useState();
    const [countCheck, setCountCheck] = useState(0);

    const [disabledCheck, setDisabledCheck] = useState(false);
    const [signData, setSignData] = useState();

    //watchを使用
    const watchValues = watch()
    useEffect(() => {
        if (isComplete === 2) {
            setValueOnChange(!valueOnChange)
        }
    }, [watchValues])

    const checkCount = (status, index) => {
        if (status === true) {
            setCountCheck((prevCount) => prevCount + 1)
            checkList?.forEach((value, i, array) => {
                array[index].checkStatus = 1
            })
        }
        else if (status === false) {
            setCountCheck((prevCount) => prevCount - 1)
            checkList?.forEach((value, i, array) => {
                array[index].checkStatus = 0
            })
        }
    }

    useEffect(() => {
        let upDateArray = JSON.parse(JSON.stringify(currentState));
        upDateArray = getValues();
        setCurrentState(upDateArray)
    }, [valueOnChange])


    useEffect(() => {
        //親フォームで取得した点検項目の値をセット
        if (currentState) {
            Object.entries(currentState).forEach(([key, value]) => {
                setValue(key, value)
            })
            setIsComplete(isComplete + 1)
        }
    }, [props.isEffectDone])


    useEffect(() => {
        //セットした値を元にチェックボックスへ反映
        if (isComplete === 2) {
            setResetValues(!resetValues)
        }
    }, [isComplete])

    const validationRules = {
        confirmAdress: {
            validate: (value) => {
                props.onError("confirmAdress", false)
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            props.onError("confirmAdress", true)
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
            }
        },
        confirmPhone: {
            validate: (value) => {
                props.onError("confirmPhone", false)
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            props.onError("confirmPhone", true)
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
            }
        },
        other: {
            validate: (value) => {
                props.onError("other", false)
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            props.onError("other", true)
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
            }
        },
        afterAddress: {
            validate: (value) => {
                props.onError("afterAddress", false)
                if (value) {
                    let counter = 0
                    for (let i = 0; i < value.length; i++) {
                        if (value[i].match(/^[^ -~｡-ﾟ]/)) {
                            counter += 2
                        } else {
                            counter += 1
                        }
                        if (counter > 80) {
                            props.onError("afterAddress", true)
                            return '全角で40文字、半角で80文字以内で入力してください。'
                        }
                    }
                }
            }
        }
    }

    const handleCheckListValues = (returnValue) => {
        if (!Object.keys(returnValue)[0]) return;
        for (let i = 0; i < Object.keys(returnValue).length; i++) {
            setValue(Object.keys(returnValue)[i], String(Object.values(returnValue)[i]))
        }
        setValueOnChange(!valueOnChange)
    };
    return (
        <React.Fragment>
            <Typography sx={{ fontSize: '2rem', }}>3　確認事項</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.7rem', }}>1　長期使用製品安全点検制度（法定点検）</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }} alignItems="center">
                    <Controller
                        control={control}
                        name="syoyusyaHenso"
                        defaultValue="0"//初期値を設定
                        render={({ field }) => (
                            <FormControlLabel
                                sx={{ transform: "scale(1.2)", py: 0.8, display: 'flex', }}
                                control={
                                    <Checkbox
                                        {...field}
                                        id="syoyusyaHenso"
                                        checked={field.value === "1"}//値が1のときチェックを付ける
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                        onChange={(event) => {
                                            const isChecked = event.target.checked;
                                            const value = isChecked ? "1" : "0"
                                            field.onChange(value)
                                        }}
                                    />
                                }
                                label={<Typography sx={{ fontSize: '1.3rem', }}><font color="red">　<b>所有者票の返送</b></font>　　　</Typography>} labelPlacement="end"
                            />
                        )}
                    />
                    <Controller
                        control={control}
                        name="syoyusya"
                        render={({ field }) => (
                            <Grid >
                                <ToggleButtonGroup
                                    id="syoyusya"
                                    value={field.value === "0" ? null : field.value}
                                    exclusive
                                    disabled={props.disabled}
                                    sx={{
                                        minWidth: 180,
                                        minHeight: 10,
                                        backgroundColor: "#289bdf",
                                        color: "#FFFFFF",

                                    }}
                                    onChange={(event, newValue) => {
                                        field.onChange(newValue === null ? "0" : newValue);
                                    }}
                                >
                                    <ToggleButton
                                        value={"1"}
                                        disabled={props.disabled}
                                        sx={{
                                            minWidth: 95,
                                            fontSize: 18,
                                            padding: 0.6,
                                            bgcolor: "#F0F8FF",
                                            color: "#BBBBBB",
                                            "&.Mui-selected": {
                                                color: "#EEEEEE",
                                            },
                                            '&:hover': props.disabled
                                                ? {}
                                                : {
                                                    backgroundColor: 'primary.light',
                                                    color: '#EEEEEE'
                                                },
                                        }}>
                                        未
                                    </ToggleButton>
                                    <ToggleButton value={"2"}
                                        sx={{
                                            minWidth: 95,
                                            fontSize: 18,
                                            padding: 0.6,
                                            bgcolor: "#F0F8FF",
                                            color: "#BBBBBB",
                                            "&.Mui-selected": {
                                                color: "#EEEEEE",
                                            },
                                            '&:hover': props.disabled
                                                ? {}
                                                : {
                                                    backgroundColor: 'primary.light',
                                                    color: '#EEEEEE'
                                                },
                                        }}>
                                        済
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Grid>
                        )}
                    />
                    <Grid container sx={{ pl: 3.2, py: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>*対象製品：①　石油給湯器　②石油風呂釜</Typography>
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>メーカーによる自主点検（任意）となるもの</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>①　ビルトイン式電気食器洗機　</Typography>
                        <Typography sx={{ fontSize: '1.5rem', }}>②　浴室用電気乾燥機　</Typography>
                        <Typography sx={{ fontSize: '1.5rem', }}>③　屋内式ガス瞬間給湯器　</Typography>
                        <Typography sx={{ fontSize: '1.5rem', }}>④　屋内式ガスふろがま　　　　</Typography>
                        <Typography sx={{ fontSize: '1.5rem', }}>⑤　FF式石油風暖房機　</Typography>
                    </Grid>
                </Grid>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>長期優良住宅にお住まいの方</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>長期優良住宅は、法律に基づいた定期点検記録を保管する必要があります。</Typography>
                        <Typography sx={{ fontSize: '1.5rem', }}>行政庁等より報告を求められた時には、この点検記録をご提出ください。</Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>住所・電話の確認</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="confirmAdress"
                                defaultValue=""//初期値に空文字を設定
                                rules={validationRules.confirmAdress}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}//fieldを参照させテキストボックスの入力内容とreact hook formを連携させる
                                        id="confirmAdress"
                                        label="住所"
                                        variant="standard"
                                        sx={{ width: 500 }}
                                        error={fieldState.invalid}
                                        helperText={fieldState.error?.message}
                                        inputProps={{
                                            maxLength: 80,//入力可能上限文字数を設定
                                            style: { fontSize: '1.5rem' }　//入力内容の文字サイズを変更,ここでは1.5remを指定
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="confirmPhone"
                                defaultValue=""//初期値に空文字を設定
                                rules={validationRules.confirmPhone}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}//fieldを参照させテキストボックスの入力内容とreact hook formを連携させる
                                        id="confirmPhone"
                                        label="電話番号"
                                        variant="standard"
                                        sx={{ width: 500 }}
                                        error={fieldState.invalid}
                                        helperText={fieldState.error?.message}

                                        inputProps={{
                                            maxLength: 80,//入力可能上限文字数を設定
                                            style: { fontSize: '1.5rem' }　//入力内容の文字サイズを変更,ここでは1.5remを指定
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>今後の連絡先</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}></Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="affterAddress"
                                defaultValue=""
                                rules={validationRules.afterAddress}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        id="affterAddress"
                                        variant="standard"
                                        sx={{ width: 500 }}
                                        error={fieldState.invalid}
                                        helperText={fieldState.error?.message}

                                        inputProps={{
                                            maxLength: 80,//入力可能上限文字数を設定
                                            style: { fontSize: '1.5rem' }　//入力内容の文字サイズを変更,ここでは1.5remを指定
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>その他</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}></Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Controller
                                control={control}
                                name="other"
                                defaultValue=""
                                rules={validationRules.other}
                                render={({ field, fieldState }) => (
                                    <TextField
                                        {...field}
                                        id="other"
                                        variant="standard"
                                        sx={{ width: 500 }}
                                        error={fieldState.invalid}
                                        helperText={fieldState.error?.message}

                                        inputProps={{
                                            maxLength: 80,//入力可能上限文字数を設定
                                            style: { fontSize: '1.5rem' }　//入力内容の文字サイズを変更,ここでは1.5remを指定
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

            <Typography sx={{ fontSize: '2rem', }}>　点検項目確認</Typography>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '1.0rem', }}>お客様下記項目で気になった点をお伺いし、特記事項は本日の作業内容にご記載ください</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>建物外部</Typography>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>1.整地</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}> 状態、排水桝の状態、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.基礎</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}> 基礎表面、換気の状態、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.外装材</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}> 割れ、欠け、ヒビ、ジョイント部シーリング、取合部シーリング</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.外壁</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>壁パネルの状態、雨水の侵入、木部の劣化</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>5.バルコニー</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>雨水の侵入、柱化粧飾りの通気状態、木部の劣化</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>6.屋根（目視）</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>屋根葺材、雨水の侵入、板金の状態</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>7.塗装全般</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>外部建具、外装材の状態、板金の状態</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>8.フラワーBOX</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>取付の状態、金具の状態、取合部</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>9.妻飾り</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>取付の状態、金具の状態、取合部</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>外部建具</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Typography sx={{ fontSize: '1.7rem', }}>1.玄関ドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>'開閉状況、パッキン、金具、給油</Typography>
                    </Grid>
                    <Typography sx={{ fontSize: '1.7rem', }}>2.バルコニードア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>開閉状況、パッキン、金具、給油</Typography>
                    </Grid>
                    <Typography sx={{ fontSize: '1.7rem', }}>3.スライディングドア</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>開閉状況、パッキン、金具、給油</Typography>
                    </Grid>
                    <Typography sx={{ fontSize: '1.7rem', }}>4.窓</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>開閉状況、パッキン、金具、給油',</Typography>
                    </Grid>
                    <Typography sx={{ fontSize: '1.7rem', }}>5.共通：開口部防水</Typography>
                    <Grid container sx={{ pl: 3.2, pb: 2 }}>
                        <Typography sx={{ fontSize: '1.5rem', }}>三方シーリング、水切り差込部、両端シーリング</Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>建物内部</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.クロス</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>剝れ、浮き</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.階段</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.床</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.内部ドア</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>開閉状況、パッキン、金具、給油</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>水回り</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.浴室</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具、シーリング</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.キッチン</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.洗面台</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具、その他</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>4.洗濯機置場洗面台</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>各種器具</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>設備</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.24時間換気</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>フィルター、熱交換素子、寒冷地仕様</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>2.局所換気</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>フィルター</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>3.冷暖房設備</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 2 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>エアコンの状況、寒冷地仕様、スライム対策</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 3.2 }}>
                <Typography sx={{ fontSize: '2rem', }}>特殊</Typography>
                <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.パイプスペース</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>床下空間の状態、配管</Typography>
                        </Grid>
                    </Grid>
                    <Grid container sx={{ pl: 3.2, pt: 1.5, pb: 1 }}>
                        <Typography sx={{ fontSize: '1.7rem', }}>1.パイプスペース</Typography>
                        <Grid container sx={{ pl: 3.2, pb: 1.5 }}>
                            <Typography sx={{ fontSize: '1.5rem', }}>通気、断熱材</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >

        </React.Fragment>
    )
}
